import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useInView } from "framer-motion";
import "./GalleryInternationalPromotions.css";

const INTERNATIONAL = [
  {
    id: "ip-01",
    country: "Egypt",
    code: "EGY",
    flag: "🇪🇬",
    img: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?q=80&w=900&auto=format&fit=crop",
  },
  {
    id: "ip-02",
    country: "Malaysia",
    code: "MYS",
    flag: "🇲🇾",
    img: "https://images.unsplash.com/photo-1515187029135-18ee286d815b?q=80&w=900&auto=format&fit=crop",
  },
  {
    id: "ip-03",
    country: "Qatar",
    code: "QAT",
    flag: "🇶🇦",
    img: "https://images.unsplash.com/photo-1560439514-4e9645039924?q=80&w=900&auto=format&fit=crop",
  },
  {
    id: "ip-04",
    country: "UAE",
    code: "UAE",
    flag: "🇦🇪",
    img: "https://images.unsplash.com/photo-1528605248644-14dd04022da1?q=80&w=900&auto=format&fit=crop",
  },
  {
    id: "ip-05",
    country: "Saudi Arabia",
    code: "KSA",
    flag: "🇸🇦",
    img: "https://images.unsplash.com/photo-1511578314322-379afb476865?q=80&w=900&auto=format&fit=crop",
  },
  {
    id: "ip-06",
    country: "South Korea",
    code: "KOR",
    flag: "🇰🇷",
    img: "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?q=80&w=900&auto=format&fit=crop",
  },
];

const PassportCard = ({ c, i }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.35 });

  return (
    <Link
      ref={ref}
      to={`/internationalpromotionsmedia/${c.id}`}
      className={`gip-passport-card ${isInView ? "gip-stamped" : ""}`}
      style={{ "--gip-delay": `${i * 110}ms` }}
      aria-label={`Open photo album: ${c.country}`}
    >
      <div className="gip-photo">
        <img src={c.img} alt={c.country} loading="lazy" />
        <span className="gip-photo-sheen" aria-hidden="true" />
      </div>

      <p className="gip-country">{c.country}</p>
      <span className="gip-code">{c.code}</span>
    </Link>
  );
};

const GalleryInternationalPromotions = () => {
  return (
    <section className="gip-section" id="internationalpromotions">
      <div className="gip-security-pattern" aria-hidden="true" />

      <div className="clean-breadcrumb-wrapper">
        <nav className="about-style-breadcrumb" aria-label="Breadcrumb">
          <Link to="/" className="bc-home-link">
            HOME
          </Link>
          <span className="bc-slash">/</span>
          <Link to="/gallery" className="bc-home-link">
            MEDIA &amp; GALLERY
          </Link>
          <span className="bc-slash">/</span>
          <span className="bc-active-page">INTERNATIONAL PROMOTIONS</span>
        </nav>
      </div>

      <div className="gip-header">
        <span className="gip-eyebrow">Beyond borders</span>
        <h2 className="gip-title">International Promotions</h2>
        <p className="gip-subtitle">
          Every stamp below is a market that opened its doors to Bharat Buildcon
          — passport pages from a genuinely global expo.
        </p>
      </div>

      <div className="gip-grid">
        {INTERNATIONAL.map((c, i) => (
          <PassportCard key={c.id} c={c} i={i} />
        ))}
      </div>
    </section>
  );
};

export default GalleryInternationalPromotions;
